<template>
  <div class="ultra-collapsable-category-container">
    <!-- CLICKABLE -->
    <button
      class="ultra-collapsable-category"
      @click="is_collapsed = !is_collapsed"
      :disabled="is_disabled"
    >
      <!-- CATEGORY DESCRIPTOR -->
      <TText
        :value="value"
        :text="description"
        class="collapsable-category-header-descriptor"
        :font_weight="font_weight || 400"
        size="12"
        align="left"
        :color="color"
      />
      <div
        class="d-flex collapsable-category-header-middle"
        :style="`color: ${color};`"
      >
        <slot
          name="header-middle"
          :is_collapsed="is_collapsed"
        />
      </div>
      <!-- ARROW ON THE RIGHT -->
      <TIcon
        v-if="!is_disabled"
        :style="is_collapsed ? '' : 'transform: rotate(90deg)'"
        name="chevron-right"
        :color="color"
      />
    </button>

    <!-- ACTUAL CONTENT -->
    <slot
      name="content"
      :is_collapsed="is_collapsed"
    />
  </div>
</template>

<script>
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TText from '@/components/Taktify/TText.component.vue'
  export default {
    components: {
      TIcon,
      TText
    },

    props: [
      'description', // is string, contains name of category shown on left side
      'value', // is string, contains name of category with language feature
      'color', // is string, contains hexadecimal value of color
      'is_disabled', // is boolean, controls expandability
      'init_expanded', // is boolean, controls initial collapsed state
      'watch_is_collapsed', //prop to tell if cat should be collapsed
      'font_weight', // is number, contains font-weight in form of 100, 200, 300, etc.
    ],

    data: () => ({
      is_collapsed: true, // can be collapsed and can show different content for either state
    }),
    watch: {
      watch_is_collapsed() {
        this.is_collapsed = !this.watch_is_collapsed;
      }
    },
    mounted() {
      this.is_collapsed = !this.init_expanded;
    },
  }
</script>

<style>
  .ultra-collapsable-category {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    outline: none;
  }
  .ultra-collapsable-category-container {
    padding-bottom: 10px;
    width: 100%;
  }
  .collapsable-category-header-descriptor {
    flex: 1 1 0px;
  }
  .collapsable-category-header-middle {
    font-weight: 300;
    font-size: 10pt;
    padding: 0 8px;
  }
</style>
